import { render, staticRenderFns } from "./flowers-page.vue?vue&type=template&id=d51a3c74&lang=pug&"
import script from "./flowers-page.vue?vue&type=script&lang=js&"
export * from "./flowers-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports